<template>
    <transition name="fade">
        <div v-if="duplicationWarning.show" class="duplication-overlay">
            <div class="duplication-overlay-content">
                <div class="duplication-icon">
                    <i class="fas fa-copy fa-3x"></i>
                </div>
                
                <h4 class="mt-4 mb-3">{{ duplicationWarning.message }}</h4>
                <p v-if="duplicationWarning.jobMessage" class="duplication-subtext mb-4">
                    {{ duplicationWarning.jobMessage }}
                </p>
                
                <button class="btn btn-primary btn-back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                    Go Back
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'DuplicationOverlay',
    
    computed: {
        ...mapState({
            duplicationWarning: state => state.deliverables.duplicationWarning
        })
    },
    
    methods: {
        goBack() {
            this.$store.dispatch('hideDuplicationWarning');
            this.$router.go(-1);
        }
    },
    
    watch: {
        'duplicationWarning.show': function(newVal) {
            const contentDiv = document.getElementById('content');
            if (contentDiv) {
                if (newVal) {
                    contentDiv.style.overflow = 'hidden';
                } else {
                    contentDiv.style.overflow = '';
                }
            }
        }
    }
};
</script>

<style scoped>
.duplication-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    backdrop-filter: blur(5px);
}

.duplication-overlay-content {
    background: white;
    border-radius: 12px;
    padding: 40px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    text-align: center;
    animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.duplication-icon {
    color: #6c757d;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.duplication-overlay-content h4 {
    color: #495057;
    font-weight: 600;
}

.duplication-subtext {
    color: #6c757d;
    font-size: 15px;
}

.duplication-message {
    font-size: 18px;
    color: #333;
    margin-bottom: 25px;
    font-weight: 500;
}

.btn-back {
    padding: 12px 40px;
    font-weight: 600;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 16px;
}

.btn-back:hover {
    transform: translateY(-2px);
    background-color: #4C9850!important;
    border-color: #4C9850!important;;
}

.btn-back i {
    margin-right: 8px;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
